'use strict';

exports.__esModule = true;
exports.CloseButtonStyled = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: ', 'px;\n  color: ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: ', 'px;\n  color: ', ';\n  ', ';\n  ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Bibliothek (2026-06): zentrales Close-X-Primitiv. Konsolidiert die 7
// inline-duplizierten ButtonClose (faTimes, navy, absolut positioniert). Kapselt
// die Optik (transparent, navy-X, flex-zentriert, absolut); Position (top/right)
// + optionaler z-index kommen per Prop vom Konsumenten. Token-Auflösung mit
// Fallback-Kette analog Card/CardStyled.js.

// tone steuert die Icon-Farbe. secondary = navy (Default, deckt alle 7 bisherigen
// Close-X ab — die trugen alle theme.secondary). Fallback spiegelt den echten
// Token-Wert aus shared/styles/theme.js (greift nur ohne vollstaendigen ThemeProvider).
var resolveColor = function resolveColor(_ref) {
  var theme = _ref.theme,
      tone = _ref.tone;

  switch (tone) {
    case 'secondary':
    default:
      return theme.secondary || '#183a64';
  }
};

// z-index nur emittieren, wenn der Konsument einen Wert setzt (Modal braucht 1, um
// ueber dem reactjs-popup-Inhalt zu liegen). Sonst KEINE z-index-Regel -> render-
// neutral fuer die uebrigen Close-X, die nie eins trugen.
var resolveZIndex = function resolveZIndex(_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex === undefined || zIndex === null ? '' : 'z-index: ' + zIndex + ';';
};

// Position nur emittieren, wenn der Konsument den Wert setzt — sonst KEINE Regel
// (statt eines ungueltigen `top: ;`). Alle aktuellen 8 Konsumenten setzen top+right;
// defensiv fuer kuenftige Konsumenten, die das Primitiv anders verankern.
var resolveSide = function resolveSide(side) {
  return function (props) {
    return props[side] === undefined || props[side] === null ? '' : side + ': ' + props[side] + ';';
  };
};

var CloseButtonStyled = exports.CloseButtonStyled = _styledComponents2.default.button(_templateObject, function (_ref3) {
  var size = _ref3.size;
  return size;
}, resolveColor, resolveSide('top'), resolveSide('right'), resolveZIndex);